import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const BlockedApi = {
  fetchProfiles: async (gender, userId, page = 1, searchQuery = "") => {
    try {
      const params = {
        gender,
        user_id: userId,
        country: "",
        region: "",
        interests: "",
        search_query: searchQuery,
        page,
      };

      const response = await axiosInstance.get(Configs.myBlockedEp, { params });
      console.log("Gender:", gender);
      console.log("User id:", userId);
      console.log("Blockeds response:", response);

      if (response.status === 200) {
        return response.data || [];
      } else {
        console.error("Failed to load profiles");
        return [];
      }
    } catch (error) {
      console.error("Error fetching profiles:", error);
      return [];
    }
  },
};

export default BlockedApi;
